module.exports = __webpack_public_path__ + "img/private-pizzeriano3-pizzas.684e8b01.jpeg";